import React, { memo } from 'react';
import { globalTranslationKeys } from '../../enums/translations';
import { useTranslation } from '@pascal/pascal-core';

function AboutHashComp({ scrollRef }) {
  const t = useTranslation();
  return (
    <div className='lotto-modal-par-holder' ref={scrollRef}>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P1)}</p>
      <p className='lotto-modal-par'>
        F17E677EDC9508018901DA79C2B520358E7F212A9E1F12BFF07F2D94B9693C67353F4CFA1A609B4D22FDAA995D28B51506DE4E4338FB2B4A2148CD11C3A5D9CE
      </p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P2)}</p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P3)}</p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P4)}</p>
      <p className='lotto-modal-par'>
        1. {t(globalTranslationKeys.FAIRNESS_P5)}:
        <br />
        2. {t(globalTranslationKeys.FAIRNESS_P6)}
        <br />
        3. {t(globalTranslationKeys.FAIRNESS_P7)}
        <br />
        4. {t(globalTranslationKeys.FAIRNESS_P8)}
        <br />
      </p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P9)}</p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P10)}</p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P11)}</p>
      <p className='lotto-modal-par'>
        F17E677EDC9508018901DA79C2B520358E7F212A9E1F12BFF07F2D94B9693C67353F4CFA1A609B4D22FDAA995D28B51506DE4E4338FB2B4A2148CD11C3A5D9CE
      </p>
      <p className='lotto-modal-par'>{t(globalTranslationKeys.FAIRNESS_P12)}</p>
    </div>
  );
}

AboutHashComp.displayName = 'AboutHash';
export const AboutHash = memo(AboutHashComp);
